/**
 * Profile URL generation utilities
 */

/**
 * Generate public profile URL from username
 */
export function getProfileUrl(username: string): string {
  return `/profile/${username}`
}

/**
 * Generate full public profile URL (with domain)
 */
export function getFullProfileUrl(username: string): string {
  if (typeof window === 'undefined') {
    return `${import.meta.env.VITE_APP_URL || 'https://headhunter.tn'}/profile/${username}`
  }
  return `${window.location.origin}/profile/${username}`
}

/**
 * Extract username from profile URL
 */
export function getUsernameFromUrl(url: string): string | null {
  const match = url.match(/\/profile\/([a-z0-9-]+)/)
  return match ? match[1] : null
}

/**
 * Check if a URL is a profile URL
 */
export function isProfileUrl(url: string): boolean {
  return /\/profile\/[a-z0-9-]+/.test(url)
}
